import React, { useState } from 'react';
import { Typography, Box, Button, useMediaQuery, useTheme, Grid } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import { StepButtonBar } from '../OtherRequirementWizard/StepButtonBar';
import { StepProps } from './types';
import UpdateConnectionInfo from './UpdateConnectionInfo';

interface Step5LawConnectionActionSelectProps extends StepProps {
  selectedAction?: SelectOption | null;
  onActionSelect: (action: SelectOption) => void;
  currentStepName: string;
  updateConnectionInfo: any;
  setUpdateConnectionInfo: (info: any) => void;
}
const PRIMARY = '#c4122f';

const Step5LawConnectionActionSelect = ({
  onNext,
  onBack,
  onCancel,
  isFirstStep,
  selectedAction,
  onActionSelect,
  currentStepName,
    updateConnectionInfo,
  setUpdateConnectionInfo,
}: Step5LawConnectionActionSelectProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [localSelected, setLocalSelected] = useState<SelectOption | null>(selectedAction || null);
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  const actionOptions = [
    { label: formatMessage({ id: 'form.add', defaultMessage: 'Add' }), value: 'add' },
    { label: formatMessage({ id: 'form.delete', defaultMessage: 'Delete' }), value: 'delete' },
  ];

  const handleActionSelect = (action: SelectOption) => {
    setLocalSelected(action);
  };

  const handleNext = () => {
    if (localSelected) {
      onActionSelect(localSelected);
      onNext();
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '350px',
          }}
        >
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <Grid container spacing={3} justifyContent="center">

              {actionOptions.map((action) => (
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }} key={String(action.value)}>

                  <Button
                    variant={localSelected?.value === action.value ? 'contained' : 'outlined'}
                    onClick={() => handleActionSelect(action)}
                    style={{
                      padding: isMobile ? '18px 24px' : '22px 32px',
                      fontSize: isMobile ? '14px' : '16px',
                      fontWeight: 700,
                      color: localSelected?.value === action.value ? '#fff' : PRIMARY,
                      background: localSelected?.value === action.value ? PRIMARY : 'transparent',
                      width: '100%',
                      minWidth: '230px',
                      borderRadius: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      transition: 'all 0.2s ease',
                      border: `2px solid ${PRIMARY}`,
                    }}
                  >
                    {action.label}
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Box>
        </div>
        <UpdateConnectionInfo
        updateConnectionInfo={updateConnectionInfo}
        currentStepName={currentStepName}
        onUpdate={setUpdateConnectionInfo}
      />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="form.next"
          nextDisabled={!localSelected}
          formatMessage={formatMessage}
          showBack={!isFirstStep}
        />
      </Box>
    </div>
  );
};

export default Step5LawConnectionActionSelect;
